module.exports = __webpack_public_path__ + "img/COM-i-2-I.bfe9d4bb.png";